import {
  QueryTicketDto,
  QueryEvent,
} from '@restore/queries/queries.types';
import { FC, ReactNode } from 'react';
import { QueryHeader } from '@components/Queries/QueryPage/components/QueryHeader';
import { QueryBody } from '@components/Queries/QueryPage/components/QueryBody';
import { QueryInfo } from '@components/Queries/QueryPage/components/QueryInfo';
import { Tabs } from '@dynamika-shared/ui/Tabs/Tabs';
import { QueryChat } from '@components/Queries/QueryPage/components/QueryChat';
import { useQueryCapabilities } from '@components/Queries/flow/useQueryCapabilities';
import { useAppSelector } from '@hooks/redux';
import { selectAuthView } from '@restore/auth/auth.slice';
import { UserRoles } from '@dynamika-shared/types/auth';
import { Button } from '@dynamika-shared/ui/Button/Button';

const tabs = (query: QueryTicketDto) => [
  {
    key: '1',
    label: <span className='text-1624'>Query Communication</span>,
    children: <QueryChat query={query} />,
  },
];

export type QueryPageProps = {
  loading?: boolean;
  query: QueryTicketDto;
  error?: unknown;
  topRightControls?: ReactNode;
  isUpdating?: boolean;
  triggerAction?: (event: QueryEvent) => void;
};

export const QueryPage: FC<QueryPageProps> = ({
  query,
  topRightControls,
  isUpdating,
  triggerAction,
}) => {
  const authView = useAppSelector(selectAuthView);
  const { selectedRole } = authView;
  const capabilities = useQueryCapabilities(query, selectedRole as UserRoles);

  if (!query) return null;
  return (
    <div className='h-[calc(100vh-184px)]'>
      <QueryHeader query={query} topRightControls={topRightControls} />
      <div className='flex gap-4 h-full mt-4'>
        <QueryInfo query={query} />
        <div className='flex flex-col flex-1 min-h-0'>
          <QueryBody query={query} />
          <Tabs
            className='flex-1 min-h-0'
            defaultActiveKey={'1'}
            items={tabs(query)}
          />
          {capabilities.canSendMessage && (
            <div className='w-full mt-2'>
              <Button
                type='secondary'
                onClick={() => triggerAction?.(QueryEvent.SEND_MESSAGE)}
                disabled={isUpdating}
                className='w-full h-5  flex items-center justify-center transition-colors'
                iconType='addNote'
              >
                Add a Note
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
